import get from 'lodash.get'

const DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
}

const defaultStore = {
  state: {
  }
}

/**
 * Build all the headers for all services
 * @param {Object} headers
 * @return {Object} headers with default values
 */
function build (headers = {}) {
  const appStore = process.env.NODE_ENV !== 'test' ? (require(`../../store/store`)).default : defaultStore

  let token = get(appStore, 'state.users.currentUser.token')

  if (token) {
    DEFAULT_HEADERS['Authorization'] = `Bearer ${token}`
  }

  const header = {
    ...DEFAULT_HEADERS,
    ...headers
  }

  return header
}

export function buildHeaders (headers = {}) {
  return build(headers)
}
export default build
